import { LinearProgress, styled } from '@mui/material';
import Switch from '@mui/material/Switch';
import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import packageJson from '../../package.json';
import Chemin from '../components/Chemin';
import ErrorPopup from '../components/ErrorPopup';
import Navigation from '../components/Navigation';
import { ProfileDetailSkeleton } from '../components/skeletons';
import { PoliceDefaut } from '../helpers/contants';
import { useDelayedLoading } from '../hooks/useDelayedLoading';
import { getParametres, getRetention, setParametres, setRetention } from '../redux/authService';
import { refreshToken } from '../redux/profilService';
import '../styles/parametres.css';
import textConnect from '../textConnect.json';

const Parametres = () => {
  const monProfil = useSelector(state => state.profil.profil);
  const accessToken = useSelector(state => state.user.access);
  const refresh_token = useSelector(state => state.user.refresh);

  const mesParametres = useSelector(state => state.user.parametres);
  const location = useLocation();
  const dispatch = useDispatch();
  const [loadParam, setLoadParam] = useState(false);
  const [retention, setRetentionDays] = useState(30);
  const [loadRetention, setLoadRetention] = useState(false);

  const [netStatus, setNetStatus] = useState(() => {
    if (navigator.onLine) {
      console.log('Connected to network.');
      return true;
    } else {
      return false;
    }
  });

  useEffect(() => {
    window.ononline = e => {
      console.log('Connected to network.');
      setNetStatus(true);
    };
    window.onoffline = e => {
      console.log('Network connection lost.');
      setNetStatus(false);
    };
  }, [netStatus]);

  const parametrer = parametre => {
    setLoadParam(true);
    setParametres(accessToken, parametre)
      .then(response => {
        // console.log('paramètre changé')
        getParametres(accessToken).then(reponse => {
          dispatch({
            type: 'user/addParametres',
            payload: reponse.data,
          });
          setLoadParam(false);
        });
      })
      .catch(erreur => {
        setLoadParam(false);
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');

              setLoading(false);
              parametrer(parametre);
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
      });
  };

  const changerRetention = days => {
    setLoadRetention(true);
    setRetention(accessToken, days)
      .then(() => {
        setRetentionDays(days);
        setLoadRetention(false);
      })
      .catch(() => {
        setLoadRetention(false);
      });
  };

  const [openError, setOpenError] = useState(false);
  const [msgError, setMsgError] = useState('');

  const [loading, setLoading] = useState(true);
  const showLoading = useDelayedLoading(loading, 500);

  const closeErrorHandle = () => {
    setOpenError(false);
  };

  useEffect(() => {
    dispatch({
      type: 'Profil/addChemin',
      payload: breadcrumbs_temp,
    });
    getRetention(accessToken)
      .then(res => setRetentionDays(res.data.days))
      .catch(() => {});
    getParametres(accessToken)
      .then(response => {
        dispatch({
          type: 'user/addParametres',
          payload: response.data,
        });

        setLoading(false);
      })
      .catch(erreur => {
        if (!netStatus) {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        if (erreur.response) {
          if (erreur.response.status !== 401) {
            setMsgError(textConnect.error);
            setOpenError(true);
          }
          if (erreur.response.status === 401) {
            refreshToken(refresh_token).then(async reponse => {
              dispatch({
                type: 'user/addRefresh',
                payload: reponse.data.refresh,
              });
              dispatch({
                type: 'user/addAccess',
                payload: reponse.data.access,
              });
              console.log('token refresh...');

              setLoading(false);
              // participantsList(token, id)
            });
          }
        } else {
          setMsgError(textConnect.internet);
          setOpenError(true);
        }
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //Breadcrumbs
  const breadCrumbs = useSelector(state => state.profil.chemin);
  const breadcrumbs_temp = breadCrumbs.filter(item => item.nom === 'Accueil');
  breadcrumbs_temp.push({ url: location.pathname, nom: 'Paramètres' });

  const BlueSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: 'red',
      '&:hover': {
        backgroundColor: 'rgba(23, 55, 141, 0.8)',
      },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: '#134491',
    },
  }));

  return (
    <Container fluid>
      <ErrorPopup message={msgError} open={openError} close={() => closeErrorHandle()} />

      <Row>
        <Navigation
          button={false}
          titre={'Mes paramètres'}
          photo={monProfil.photo_path}
          retour="dashboard"
          menus={true}
        />
      </Row>
      {loadParam ? (
        <Row className="" style={{ marginTop: '-7px' }}>
          <LinearProgress />
        </Row>
      ) : null}

      <Row className="p-0">
        <Chemin breadCrumbs={breadcrumbs_temp} />
      </Row>
      {/* <h1>Mes Paramètres</h1> */}

      {showLoading ? (
        <ProfileDetailSkeleton />
      ) : (
        <>
          <Row className="parametre-container mt-4">
            {mesParametres.length === 0 || mesParametres.length === undefined
              ? null
              : mesParametres.map((item, index) => {
                  return (
                    <Container key={index}>
                      <Row
                        className="d-flex justify-content-center border-bottom p-0"
                        style={{ width: '' }}
                      >
                        <Col xs={9} className="d-flex align-items-center p-0">
                          {mesParametres[index].text}
                        </Col>
                        <Col
                          className="d-flex justify-content-end p-0"
                          style={{ width: 'fit-content' }}
                        >
                          <BlueSwitch
                            disabled={loadParam ? true : false}
                            checked={mesParametres[index].etat === true ? true : false}
                            style={{
                              color: mesParametres[index].etat === true ? '#134491' : '#f0f1f1',
                            }}
                            onChange={e => parametrer(mesParametres[index].parametre)}
                          />
                        </Col>
                      </Row>
                    </Container>
                  );
                })}
          </Row>
          <Row className="parametre-container mt-2">
            <Container>
              <Row
                className="d-flex justify-content-center border-bottom p-0 pb-2"
                style={{ width: '' }}
              >
                <Col xs={9} className="d-flex align-items-center p-0">
                  Archivage automatique des notifications lues
                </Col>
                <Col className="d-flex justify-content-end p-0" style={{ width: 'fit-content' }}>
                  <select
                    disabled={loadRetention}
                    value={retention === null ? 'null' : String(retention)}
                    onChange={e => {
                      const val = e.target.value === 'null' ? null : parseInt(e.target.value, 10);
                      changerRetention(val);
                    }}
                    style={{
                      fontFamily: PoliceDefaut,
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                      padding: '4px 8px',
                      color: '#134491',
                    }}
                  >
                    <option value="7">7 jours</option>
                    <option value="14">14 jours</option>
                    <option value="30">30 jours</option>
                    <option value="90">90 jours</option>
                    <option value="null">Jamais</option>
                  </select>
                </Col>
              </Row>
            </Container>
          </Row>
          {mesParametres.length ? (
            <Row className="parametre-container mt-1">
              <p className="p-0">
                Pour clôturer mon compte - <NavLink to="/suppressionCompte">cliquer ici</NavLink>
              </p>
            </Row>
          ) : null}
          <Row className="parametre-container mt-2">
            <p
              className="p-0"
              style={{ color: '#B7B3CC', fontSize: '0.75rem', textAlign: 'center' }}
            >
              Version {packageJson.version}
              {process.env.REACT_APP_GIT_SHA
                ? ` · ${process.env.REACT_APP_GIT_SHA.slice(0, 7)}`
                : ''}
            </p>
          </Row>
          {!mesParametres.length ? (
            <Row
              style={{
                fontFamily: PoliceDefaut,
                margin: 'auto',
                width: 'fit-content',
                marginTop: '2%',
                textAlign: 'center',
                color: '#134491',
                fontSize: '150%',
              }}
            >
              Pas de paramètres disponibles
            </Row>
          ) : null}
        </>
      )}
    </Container>
  );
};

export default Parametres;
